import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconDashboard = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 17} height={props.height || 16} viewBox="0 0 17 16" fill="none">
      <path
        d="M6.5 2H3.16667C2.79848 2 2.5 2.29848 2.5 2.66667V7.33333C2.5 7.70152 2.79848 8 3.16667 8H6.5C6.86819 8 7.16667 7.70152 7.16667 7.33333V2.66667C7.16667 2.29848 6.86819 2 6.5 2Z"
        stroke={theme.colors.text.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8335 2H10.5002C10.132 2 9.8335 2.29848 9.8335 2.66667V4.66667C9.8335 5.03486 10.132 5.33333 10.5002 5.33333H13.8335C14.2017 5.33333 14.5002 5.03486 14.5002 4.66667V2.66667C14.5002 2.29848 14.2017 2 13.8335 2Z"
        stroke={theme.colors.text.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8335 8H10.5002C10.132 8 9.8335 8.29848 9.8335 8.66667V13.3333C9.8335 13.7015 10.132 14 10.5002 14H13.8335C14.2017 14 14.5002 13.7015 14.5002 13.3333V8.66667C14.5002 8.29848 14.2017 8 13.8335 8Z"
        stroke={theme.colors.text.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10.6666H3.16667C2.79848 10.6666 2.5 10.9651 2.5 11.3333V13.3333C2.5 13.7015 2.79848 14 3.16667 14H6.5C6.86819 14 7.16667 13.7015 7.16667 13.3333V11.3333C7.16667 10.9651 6.86819 10.6666 6.5 10.6666Z"
        stroke={theme.colors.text.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
